// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"642":"9149f1b6","800":"574be020"}[chunkId] + ".js";
};